import React from 'react';

import {
  Attachment,
  HTMLMessageWithScroll,
  InfoMessage,
  JsonSelectMessage,
  QuestionsMessage
} from '../models';
import { MESSAGE_TYPE_SENT } from '../utilities';

const useMessageScrollIntoView = () => {
  return React.useCallback((node, message) => {
    if (!node) return;

    const isUserMessage = message.type === MESSAGE_TYPE_SENT;
    const isInfoMessage = message instanceof InfoMessage;
    const isAttachmentMessage = message instanceof Attachment;
    const isQuestionsMessage = message instanceof QuestionsMessage;
    const isHTMLMessageWithScroll = message instanceof HTMLMessageWithScroll;
    const isJsonSelectMessage = message instanceof JsonSelectMessage;
    const shouldScrollIntoView =
      isUserMessage ||
      isInfoMessage ||
      isAttachmentMessage ||
      isQuestionsMessage ||
      isHTMLMessageWithScroll ||
      isJsonSelectMessage;

    if (shouldScrollIntoView) {
      node.scrollIntoView({ behaviour: 'smooth' });
    }
  }, []);
};

export default useMessageScrollIntoView;
